import { render, staticRenderFns } from "./pass-card.vue?vue&type=template&id=2be2a1b8&scoped=true&"
import script from "./pass-card.vue?vue&type=script&lang=js&"
export * from "./pass-card.vue?vue&type=script&lang=js&"
import style0 from "./pass-card.vue?vue&type=style&index=0&id=2be2a1b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be2a1b8",
  null
  
)

export default component.exports